export const ASSET_TYPE = {
  ALL: 'all',
  THREE_D_ONLY: '3d_only',
  THREE_D_PRINT_ONLY: '3d_print_only',
}

export const QUALITY_LEVEL = {
  ANY: 'any',
  BASIC: 'basic',
  PREMIUM: 'premium',
  PRO: 'pro',
}

export const CONTENT_SOURCE = {
  ALL: 'all',
  AI_GENERATED: 'ai_generated',
  HUMAN_CREATED: 'human_created',
}

export const PRICE_RANGE = {
  FREE: 'free',
  RANGE_2_10: 'range_2_10',
  RANGE_10_20: 'range_10_20',
  RANGE_20_50: 'range_20_50',
  RANGE_50_100: 'range_50_100',
  MORE_THAN_100: 'more_than_100',
}

export const DATE_PUBLISHED = {
  ALL_TIME: 'all_time',
  LAST_24_HOURS: 'last_24_hours',
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  LAST_3_MONTHS: 'last_3_months',
  LAST_6_MONTHS: 'last_6_months',
  LAST_12_MONTHS: 'last_12_months',
  CUSTOM: 'custom',
}

export const LICENSE_TYPE = {
  ALL: 'all',
  ROYALTY_FREE: 'royalty_free',
  ROYALTY_FREE_NO_AI: 'royalty_free_no_ai',
  CUSTOM: 'custom',
  CUSTOM_NO_AI: 'custom_no_ai',
  EDITORIAL: 'editorial',
  EDITORIAL_NO_AI: 'editorial_no_ai',
}

export const POLYGON_RANGE = {
  LOW_POLY: 'lt_20k',
  MID_POLY: 'range_20k_100k',
  HIGH_POLY: 'gt_100k',
}

export const SIZE_UNIT = {
  CM: 'cm',
  IN: 'in',
  MM: 'mm',
}

// Quick Select buckets for the 3D-print Size filter (overall print size).
export const SIZE_PRESET = {
  UNDER_5: 'under_5',
  RANGE_5_15: 'range_5_15',
  RANGE_15_30: 'range_15_30',
  RANGE_30_50: 'range_30_50',
  RANGE_50_100: 'range_50_100',
  OVER_100: 'over_100',
}

// Axes for the whole/largest print-size dimension inputs.
export const SIZE_AXIS = {
  WIDTH: 'width',
  DEPTH: 'depth',
  HEIGHT: 'height',
}

export const ADVANCED_FILTER = {
  COLLECTIONS_ONLY: 'collections_only',
  HAS_MARMOSET: 'has_marmoset',
  HAS_VIDEO: 'has_video',
  CGT_STANDARD_ONLY: 'cgt_standard_only',
}

export const CONTENT_FILTER = {
  ADULT_CONTENT_ONLY: 'adult_content_only',
  EXCLUDE_ADULT_CONTENT: 'exclude_adult_content',
}

export const PERSONAL_FILTER = {
  WISH_LIST_ONLY: 'wish_list_only',
  LIKED_MODELS_ONLY: 'liked_models_only',
}

export const PURCHASE_FILTER = {
  EXCLUDE_PURCHASED_MODELS: 'exclude_purchased_models',
  PURCHASED_MODELS_ONLY: 'purchased_models_only',
}

export const SORT_BY = {
  BEST_MATCH: 'best_match',
  TOP_SELLING: 'sales',
  NEWEST: 'newest',
  OLDEST: 'oldest',
  LOWEST_PRICE: 'lowest_price',
  HIGHEST_PRICE: 'highest_price',
  TRENDING: 'trending',
}

export const DEFAULT_STATE = {
  assetType: ASSET_TYPE.ALL,
  fileTypes: [],
  quality: [QUALITY_LEVEL.ANY],
  contentSource: CONTENT_SOURCE.HUMAN_CREATED,
  onSale: false,
  withSubscription: false,
  priceRanges: [],
  minPrice: '',
  maxPrice: '',
  datePublished: DATE_PUBLISHED.ALL_TIME,
  minDatePublished: undefined,
  maxDatePublished: undefined,
  designers: [],
  designerScopes: [],
  licenses: [LICENSE_TYPE.ALL],
  aiUsageAllowed: false,
  advancedFilters: [],
  contentFilter: undefined,
  personalFilter: undefined,
  purchaseFilter: undefined,
  polygonRanges: [],
  minPolygon: undefined,
  maxPolygon: undefined,
  styles: [],
  animated: false,
  pbr: false,
  rigged: false,
  gameReady: false,
  withRenders: false,
  tags: [],
  withMakes: false,
  threeDPrintVerified: false,
  multiColor: false,
  // 3D-print Size filter. Dimensions are max-constraints per axis ('' when unset), keyed by SIZE_AXIS;
  // sizePreset is a single Quick Select bucket. Empty objects are shared module constants — setters
  // always replace with a fresh object, never mutate.
  sizeUnit: SIZE_UNIT.CM,
  wholePrintSize: {},
  largestPrintSize: {},
  sizePreset: undefined,
  sortBy: SORT_BY.BEST_MATCH,
  keyword: '',
  // Bumped by clearKeyword so the within-results input can resync its local draft even when the
  // clear writes the same '' the store already held - see Store/slices/keyword.js.
  keywordClearCount: 0,
}
